import styled from 'styled-components';

export const StyledSentinel = styled.div`
  visibility: hidden;
`;
